export const LOADING_MAPA_CARRERA = "LOADING_MAPA_CARRERA";

export const GET_MAPA_CARRERA = "GET_MAPA_CARRERA";

export const MAPA_CARRERA_FAIL = "MAPA_CARRERA_FAIL";